import {getLogger} from "./logger";

const logger = getLogger("switchToCw4");
export const switchToCw4IfNeeded = (): void => {
    if (typeof window === "undefined") {
        return;
    }
    if (window.localStorage.getItem("has-previously-signed-in") === "1") {
        logger.log("Redirecting to CW4 as the user has previously signed in");
        document.location = "/cw4/index.html";
    }
};

export const switchToCw4 = (): void => {
    logger.log("Redirecting to CW4 for sign-in");
    document.location = "/cw4/index.html";
};
